import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { useEffect } from "react";
import { TextService } from "../../Services/TextService";

const PageSmall = (props: any) => {
    const cssClass = "Page PageSmall " + props.className;
    useEffect(() => {
        document.title = props.pageTitle ?? TextService.GetText("Common_PageTitle");

        // Meta description
        let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.name = 'description';
            document.head.appendChild(metaDesc);
        }
        metaDesc.content = props.metaDescription ?? '';

        // Robots noindex
        let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement;
        if (props.noIndex) {
            if (!metaRobots) {
                metaRobots = document.createElement('meta');
                metaRobots.name = 'robots';
                document.head.appendChild(metaRobots);
            }
            metaRobots.content = 'noindex, nofollow';
        } else if (metaRobots) {
            metaRobots.remove();
        }
    }, []);

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default PageSmall;